<script lang="ts">
  import type { HTMLButtonAttributes } from 'svelte/elements'
  import { createEventDispatcher } from 'svelte'

  interface $$Props extends HTMLButtonAttributes {
    title: string
    active: boolean
  }
  
  const dispatch = createEventDispatcher()
  
  export let active: boolean
  export let title: string;
  
  function onClicked(event: MouseEvent): void {
    if (active) return

    dispatch('click', event)
  }
  
</script>

<button class="wk-button wk-button-small wk-button-icon-right" {...$$restProps} on:click|preventDefault|stopPropagation={onClicked} active={active || null}>
  <span>{title}</span>
  <span class="wk-icon-filled-spinner-alt wk-spin"></span>
</button>


<style lang="css">
  .wk-button-icon-right .wk-spin {
    display: none;
  }
  .wk-button-icon-right[active] .wk-spin {
    display: inline-block;
  }
</style>